// extracted by mini-css-extract-plugin
export default {"shell":"ProvisioningShell_shell__XvnOq","body":"ProvisioningShell_body__mC4dF","content":"ProvisioningShell_content__+8sGn"};